import { render, staticRenderFns } from "./LoaderWithText.vue?vue&type=template&id=04cff27c&"
import script from "./LoaderWithText.vue?vue&type=script&setup=true&lang=js&"
export * from "./LoaderWithText.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./LoaderWithText.vue?vue&type=style&index=0&id=04cff27c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports